import { LeaveBalanceDTO } from "@/models/leave-balances.model";
import React, { useEffect } from "react";
import LeaveBalanceDataTable from "./table/LeaveBalanceDataTable";
import { getYearBeforeCurrent } from "@/utils/date-format";
import Dropdown, { Item } from "../form/Dropdown";
import { getLeaveBalancesOfUser } from "@/api/leave-balances";
import { toast } from "@/hooks/use-toast";

interface Props {
  userId: number;
}
function LeaveBalanceCard({ userId }: Props) {
  const [selectedYear, setSelectedYear] = React.useState<string>(new Date().getFullYear().toString());
  const [leaveBalances, setLeaveBalance] = React.useState<LeaveBalanceDTO[]>([]);
  const yearOptions: Item[] = getYearBeforeCurrent().map((year) => ({
    label: year.toString(),
    value: year.toString(),
  }));

  useEffect(() => {
    setSelectedYear(new Date().getFullYear().toString());

  }, [])

  useEffect(() => {

    const fetchLeaveBalance = async () => {
      console.log("fetching leave balance for user", userId);
      if (!userId) return;
      try {
        const res = await getLeaveBalancesOfUser(userId, Number(selectedYear));
        setLeaveBalance(res);
      }
      catch (err) {
        console.error(err);
        toast({
          variant: "destructive",
          title: "Failed to fetch leave balance",
          description: "Please try again later",
        })
      }
    };
    fetchLeaveBalance();
  }, [selectedYear, userId]);


  return (
    <div className="rounded-md w-full h-[400px] p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
      <div className=" flex items-center justify-between">
        <div className="font-bold text-lg">Leave Balance</div>
        <div className="min-w-[100px]">
          <Dropdown
            label=""
            items={yearOptions}
            selectedString={selectedYear}
            setSelectedString={setSelectedYear}
          />
        </div>

      </div>



      <div className="h-full max-h-full overflow-y-auto">
        <LeaveBalanceDataTable leaveBalances={leaveBalances} />
      </div>
    </div>
  );
}

export default LeaveBalanceCard;
